import { MutationTree } from 'vuex';
import { DirectoryState } from './types';


const mutations: MutationTree<DirectoryState> = {
  setPlatforms(state, data) {
    state.platforms = data;
  },
  setPlatformsIsLoading(state, data) {
    state.platformsIsLoading = data;
  },
  setCostCenters(state, data) {
    state.costCenters = data;
  },
  setCostCentersIsLoading(state, data) {
    state.costCentersIsLoading = data;
  },
  setCostAccounts(state, data) {
    state.costAccounts = data;
  },
  setCostAccountsIsLoading(state, data) {
    state.costAccountsIsLoading = data;
  },
};

export default mutations;
